import { MockedRequest, RequestHandler, restContext } from 'msw';
import environmentHandlers from './Environment';
import userApiHandlers from './UserApi';
import resourceCategoryHandlers from './CategoryApi';
import resourceSubcategoryHandlers from './SubcategoryApi';
import accountApiHandlers from './AccountApi';
import tokenHandlers from './TokenApi';
import documentApiHandlers from './DocumentApi';
import messageApiHandlers from './MessageApi';
import v30ApiHandlers from './V30Api';

const handlers: RequestHandler<MockedRequest, typeof restContext>[] = [
  ...environmentHandlers,
  ...userApiHandlers,
  ...accountApiHandlers,
  ...resourceCategoryHandlers,
  ...resourceSubcategoryHandlers,
  ...tokenHandlers,
  ...documentApiHandlers,
  ...messageApiHandlers,
  ...v30ApiHandlers,
];

export { default as environmentHandlers } from './Environment';
export { default as userApiHandlers } from './UserApi';
export { default as accountApiHandlers } from './AccountApi';
export { default as resourceCategoryHandlers } from './CategoryApi';
export { default as resourceSubcategoryHandlers } from './SubcategoryApi';
export { default as tokenHandlers } from './TokenApi';
export { default as documentApiHandlers } from './DocumentApi';
export { default as messageApiHandlers } from './MessageApi';

export default handlers;
